export default __webpack_public_path__ + "static/media/swiftWriter1.955abe35.png";